import React from "react";

import "./Button.css";

function Button({disabled, highlight, onClick, style, children, blinking,className}) {
    // let className = "button";
    // if (highlight) {
    //     className += " highlightedButton";
    // }
    // if (disabled) {
    //     className += " disabledButton";
    // }
    // if (blinking) {
    //     className += " blinking";
    // }

    return (
        <button className={`button ${className} ${disabled ? 'disabledButton' : ''}`.trim()} style={style} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
}

export default Button;
